function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

import EXIF from "exif-js";

//获取url上的参数
function getQueryString(name) {
  let str = window.location.href;
  let obj = {};
  getUrlFn(str, obj);
  if (obj[name] != null) return obj[name];
  return null;
}

function getUrlFn(name, obj) {
  let arr = [];
  let num = name.indexOf("?");
  arr = name.substr(num + 1).split("&");
  arr.map(btn => {
    let num2 = btn.indexOf("?");
    if (num2 !== -1) {
      getUrlFn(btn, obj);
    } else {
      let arr2 = btn.split("=");
      obj[arr2[0]] = arr2[1];
    }
  });
}

//图片压缩
function compress(fileObj, callback, Orientation) {
  let _this = this;
  // fileobj 文件对象
  // callback 回调 返回压缩后的文件
  if (fileObj.size < 307200 && (Orientation == undefined || Orientation == 1 || Orientation == 2 || Orientation == 0)) {
    callback(fileObj);
    return;
  }
  try {
    const image = new Image();
    image.src = URL.createObjectURL(fileObj);
    image.onload = function() {
      const that = this;
      // 默认按比例压缩
      let w = that.width;
      let h = that.height;
      const scale = w / h;
      w = fileObj.width || w;
      h = fileObj.height || (w / scale);
      let quality = 0.1; // 默认图片质量为0.7
      // 生成canvas
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (Orientation == undefined || Orientation == 1 || Orientation == 2 || Orientation == 0) {
        // 创建属性节点
        const anw = document.createAttribute("width");
        anw.nodeValue = w;
        const anh = document.createAttribute("height");
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(that, 0, 0, w, h);
      } else {
        // 创建属性节点
        const anw = document.createAttribute("width");
        anw.nodeValue = h;
        const anh = document.createAttribute("height");
        anh.nodeValue = w;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        if (Orientation == 3 || Orientation == 4) {
          ctx.rotate(Math.PI);
          ctx.drawImage(that, -w, -h, w, h);
        } else if (Orientation == 5 || Orientation == 6) {
          ctx.rotate(Math.PI / 2);
          ctx.drawImage(that, 0, -h, w, h);
        } else if (Orientation == 7 || Orientation == 8) {
          ctx.rotate(3 * Math.PI / 2);
          ctx.drawImage(that, -w, 0, w, h);
        }
      }
      // 图像质量
      if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {
        quality = fileObj.quality;
      }
      // quality值越小，所绘制出的图像越模糊
      const data = canvas.toDataURL("image/jpeg", quality);
      // 压缩完成执行回调
      const newFile = convertBase64UrlToBlob(data);
      callback(newFile);
    };
  } catch (e) {
    alert("压缩失败!");
  }
}

function compresstypeB(fileObj, callback) {
  var Orientation = null;
  var isRotate = true
  
  if (getIos() == 'IOS') {
    isRotate = version() <= 1340 ? true :false
  } else {
    isRotate = true
  }
  
  EXIF.getData(fileObj, function() {
    Orientation = EXIF.getTag(this, "Orientation");
    var image = new Image();
  image.src = URL.createObjectURL(fileObj);
  image.onload = function() {
    var imgWidth = this.width,
      imgHeight = this.height;
    // 控制上传图片的宽高
    if (imgWidth > imgHeight) {
      imgWidth = 400;
      imgHeight = this.height / (this.width / 400);
    } else if (imgWidth < imgHeight) {
      imgWidth = this.width / (this.height / 400);
      imgHeight = 400;
    }

    var canvas = document.createElement("canvas"),
      ctx = canvas.getContext("2d");
    canvas.width = imgWidth;
    canvas.height = imgHeight;
    if (Orientation && Orientation !== 1 && Orientation !== 0 && isRotate) {
      switch (Orientation) {
        case 6:     // 旋转90度
          canvas.width = imgHeight;
          canvas.height = imgWidth;
          ctx.rotate(Math.PI / 2);
          // (0,-imgHeight) 从旋转原理图那里获得的起始点
          ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
          break;
        case 3:     // 旋转180度
          ctx.rotate(Math.PI);
          ctx.drawImage(this, -imgWidth, -imgHeight, imgWidth, imgHeight);
          break;
        case 8:     // 旋转-90度
          canvas.width = imgHeight;
          canvas.height = imgWidth;
          ctx.rotate(3 * Math.PI / 2);
          ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
          break;
      }
    } else {
      ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
    }

    let data = canvas.toDataURL("image/jpeg", .9);
    // 压缩完成执行回调
    const newFile = convertBase64UrlToBlob(data);
    callback(newFile);
  };
  });

}

//获取手机系统版本号
function version() {
  var str= navigator.userAgent.toLowerCase();
  var ver=str.match(/cpu iphone os (.*?) like mac os/);
  return (ver[1].replace(/_/g,""))*1
}
//获取手机类型
function getIos() {
  if (!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    return 'IOS';
  } else if (navigator.userAgent.indexOf("Android 10") > -1){
    return 'Android10';
  }
}

//判断是从微信还是QQ打开
function is_QQ_WEIXIN(){
  var ua = navigator.userAgent.toLowerCase();
  if( ua.match(/MicroMessenger/i) == "micromessenger") {
    return 'WEIXIN'
  } else if (ua.match(/QQ/i)=="qq") {
    return 'QQ'
  }
}


//base64转blob
function convertBase64UrlToBlob(urlData) {
  const bytes = window.atob(urlData.split(",")[1]); // 去掉url的头，并转换为byte
  // 处理异常,将ascii码小于0的转换为大于0
  const ab = new ArrayBuffer(bytes.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  return new Blob([ab], { type: "image/jpg" });
}


export {
  IsPC,
  compress,
  getQueryString,
  compresstypeB,
  getIos,
  is_QQ_WEIXIN
};
